import { Box, Divider, Typography } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import LandingCollectionThumbnail from './LandingCollectionThumbnail';
import { CountWithIcon } from './LandingCollectionItem.parts';

import { CollectionList } from '@/shared/types';
import { Link } from '@/shared/Components';
import { PATH } from '@/shared/constants';

export interface LandingCollectionProps extends CollectionList {
  scrapsLength: number;
  isAdvertisement?: boolean;
  useScrapButton?: boolean;
}

const LandingCollectionItem = ({
  id,
  title,
  profile,
  thumbnail,
  scrapsLength,
  scrappedCount,
  viewCount = 0,
  likeCount = 0,
  thumbnailMainColor,
  isAdvertisement,
  useScrapButton,
}: LandingCollectionProps) => {
  return (
    <Box
      data-testid="landing-collection-item"
      className={twJoin(
        'flex min-w-[210px] flex-col ease-in tablet:min-w-[265px]',
        'desktop:pt-1 desktop:duration-200 desktop:hover:-translate-y-[5%]'
      )}
    >
      <Link href={`${PATH.COLLECTION}/${id}`}>
        <LandingCollectionThumbnail
          collectionId={id}
          imgSrc={thumbnail}
          count={scrapsLength}
          profileImgSrc={profile.image}
          layerColor={thumbnailMainColor}
          useScrapButton={useScrapButton}
        />
        <Box
          className={twJoin(
            'flex flex-col rounded-b-2xl border-x border-b border-w-gray-100',
            'px-4 pb-5 pt-6 tablet:px-5 tablet:pb-6 tablet:pt-7'
          )}
        >
          <Typography
            variant="body1"
            className="truncate font-medium text-w-gray-900 tablet:typo-subTitle2"
            data-testid="collection-item-title"
          >
            {title}
          </Typography>
          <Box className="flex items-center gap-2">
            {isAdvertisement && (
              <>
                <Typography
                  variant="body2"
                  className="text-w-gray-400"
                  data-testid="collection-item-ad"
                >
                  AD
                </Typography>
                <Divider isVertical className="h-3.5" />
              </>
            )}
            <Typography variant="body2" className="text-w-gray-400">
              {profile.name}
            </Typography>
          </Box>
          <Box className="flex items-center gap-3 pt-2">
            <CountWithIcon icon="small_eye" count={viewCount} />
            <CountWithIcon icon="small_like" count={likeCount} />
            <CountWithIcon icon="small_scrap" count={scrappedCount} />
          </Box>
        </Box>
      </Link>
    </Box>
  );
};

export default LandingCollectionItem;
